// frontend/src/services/calendarBlockService.js
import axiosInstance from './axiosConfig';

export const getCalendarBlocks = async () => {
    const response = await axiosInstance.get('/calendar-blocks');
    return response.data;
};

export const createCalendarBlock = async (blockData) => {
    const response = await axiosInstance.post('/calendar-blocks', blockData);
    return response.data;
};

export const deleteCalendarBlock = async (id, deleteSeries = false) => {
    const response = await axiosInstance.delete(`/calendar-blocks/${id}`, {
        params: { deleteSeries }
    });
    return response.data;
};
